import { CancelablePromise } from '../util/PromiseUtil';

export interface QueryParameters {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  [key: string]: any;
}

export interface Executor<T extends string> {
  get(
    url: T,
    headers?: RequestHeaders,
    queryParams?: QueryParameters,
    additionalParams?: Partial<RequestInit>
  ): Promise<HttpClientResponse>;
  post(
    url: T,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
    body: any,
    headers?: RequestHeaders,
    queryParams?: QueryParameters,
    additionalParams?: Partial<RequestInit>
  ): Promise<HttpClientResponse>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  put(url: T, body: any, headers?: RequestHeaders, queryParams?: QueryParameters): Promise<HttpClientResponse>;
  delete(url: T, headers?: RequestHeaders, queryParams?: QueryParameters): Promise<HttpClientResponse>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  patch(url: T, body: any, headers?: RequestHeaders, queryParams?: QueryParameters): Promise<HttpClientResponse>;
}

export interface CancelableExecutor<T extends string> {
  get(
    url: T,
    headers?: RequestHeaders,
    queryParams?: QueryParameters,
    additionalParams?: Partial<RequestInit>
  ): CancelablePromise;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  post(url: T, body: any, headers?: RequestHeaders, queryParams?: QueryParameters): CancelablePromise;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  put(url: T, body: any, headers?: RequestHeaders, queryParams?: QueryParameters): CancelablePromise;
  delete(url: T, headers?: RequestHeaders, queryParams?: QueryParameters): CancelablePromise;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  patch(url: T, body: any, headers?: RequestHeaders, queryParams?: QueryParameters): CancelablePromise;
}

export enum HeaderKeys {
  AUTHORIZATION = 'Authorization',
  DEPLOY_TENANT_AUTHORIZATION = 'Deploy-Tenant-Authorization',
  WD_TENANT_AUTHORIZATION = 'Wd-Tenant-Authorization',
  X_API_KEY = 'X-Api-Key',
  CONTENT_TYPE = 'Content-Type',
  CONTENT_LENGTH = 'content-length',
  WCP_AUTHORIZATION = 'WCP-Authorization',
  ACCEPT = 'Accept',
  COOKIE = 'Cookie',
  CACHE_CONTROL = 'Cache-Control',
  ORG_ID = 'Org-Id',
  SENTRY_TRACE = 'Sentry-Trace',
  BAGGAGE = 'Baggage',
  GRAPHQL_METRICS_HEADER = 'wd-graphql-tracing-metrics',
  X_XSRF_TOKEN = 'X-XSRF-TOKEN',
  XSRF_TOKEN = 'xsrf-token',
  SESSION_TYPE = 'Session-Type',
  WD_AGENT_TENANT_ALIAS = 'wd-agent-tenant-alias',
  WD_TENANT = 'wd-tenant',
  X_WD_WCP_APP_ID = 'x-wd-wcp-app-id',
}

export type RequestHeaders = {
  [key in HeaderKeys]?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
export interface HttpClientResponse<T = any> {
  requestHeaders: RequestHeaders;
  responseHeaders: RequestHeaders;
  body: T;
  response: Response;
}

export interface HttpErrorResponse {
  message: string;
  status: number;
  errorCode?: number;
}

export enum MimeType {
  PDF = 'application/pdf',
  PLAINTEXT = 'text/plain',
  HTML = 'text/html',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  MPEG = 'audio/mpeg',
  OGG = 'audio/ogg',
  AUDIO = 'audio/*',
  APPLICATION = 'application/*',
  ZIP = 'application/zip',
  JSON = 'application/json',
  YAML = 'application/x-yaml',
  MULTIPART = 'multipart/form-data',
  EVENT_STREAM = 'text/event-stream',
}

export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export interface Endpoint<T> {
  [key: string]: T | ((val: string) => T);
}
